export default "__VITE_ASSET__Ey$0WCN3__"